import { StatusPicker } from 'components/atoms/status-picker';
import { withAccess } from 'hooks/rbac/withAccess';

export const RbacStatusPicker = withAccess(StatusPicker);
export const RbacStatusPickerTrigger = withAccess(StatusPicker.Trigger);
